export default {
  apiKey: "AIzaSyD6NZZ5icfrX2GXjrryiix7p26tDtfjE_w",
  authDomain: "zdnacloud-prodenv-eu-t.firebaseapp.com",
  projectId: "zdnacloud-prodenv-eu-t",
  storageBucket: "zdnacloud-prodenv-eu-t.appspot.com",
  messagingSenderId: "723275989615",
  appId: "1:723275989615:web:1b7d04b9090834884b439a",
};